export default {
  title: 'Oops!',
  message1: 'If you have trouble signing in to ',
  message3: ', please ',
  message4: 'contact us',
  message5: '.',
};
